import { ref } from "vue";
import { defineStore } from "pinia";
import ApiClient from "@api/client";

export default defineStore("materials", () => {
  const items = ref<IMaterialEntry[]>([]);
  const categories = ref<string[]>([]);
  const subcategories = ref<string[]>([]);
  const specials = ref<string[]>([]);

  const getItems = async () => {
    // get materials
    const apiClient = new ApiClient();
    const requestItems = await apiClient.getMaterials();

    // fetch data
    const materials = requestItems.data;
    if (!materials) {
      throw new Error('No materials found');
    }

    // go through materials and get filters
    const categoriesSet = new Set<string>();
    const subcategoriesSet = new Set<string>();
    const specialsSet = new Set<string>();
    for (const material of materials) {
      if(material.name === "" || material.name === "OUT") continue;
      if(material.category) categoriesSet.add(material.category);
      if(material.subcategory) subcategoriesSet.add(material.subcategory);
      if(material.special) specialsSet.add(material.special);
    }

    // set to categories state
    categories.value = [...categoriesSet];
    subcategories.value = [...subcategoriesSet];
    specials.value = [...specialsSet];

    // set to items state and return
    items.value = materials;
    return materials;
  };

  const filterItems = (filters: IFilters) => {
    // prepare items & filters
    const itemCopy = [...items.value];

    // if filters are empty, return all items
    if (filters.text === "" && filters.categories.length === 0 && filters.subcategories.length === 0 && filters.specials.length === 0) {
      return itemCopy;
    }

    // if text contains an exact id match, return that item
    const exactIdMatch = itemCopy.find((item) => item.id.toLowerCase() === filters.text.toLowerCase());
    if (exactIdMatch) {
      return [exactIdMatch];
    }

    // filter items
    return itemCopy.filter((item) => {
      const textNameFilter = filters.text ? item.name.toLowerCase().includes(filters.text.toLowerCase()) : true;
      const textCategoryFilter = filters.text ? (item.category?.toLowerCase().includes(filters.text.toLowerCase()) ?? false) : true;
      const textSubcategoryFilter = filters.text ? (item.subcategory?.toLowerCase().includes(filters.text.toLowerCase()) ?? false) : true;
      const textSpecialFilter = filters.text ? (item.special?.toLowerCase().includes(filters.text.toLowerCase()) ?? false) : true;
      const categoryFilter = filters.categories.length > 0 ? (item.category ? filters.categories.includes(item.category) : false) : true;
      const subcategoryFilter = filters.subcategories.length > 0 ? (item.subcategory ? filters.subcategories.includes(item.subcategory) : false) : true;
      const specialFilter = filters.specials.length > 0 ? (item.special ? filters.specials.includes(item.special) : false) : true;

      console.log({ textNameFilter, textCategoryFilter, textSubcategoryFilter, textSpecialFilter, categoryFilter, subcategoryFilter, specialFilter });

      // return filtered items
      return (textNameFilter || textCategoryFilter || textSubcategoryFilter || textSpecialFilter) && categoryFilter && subcategoryFilter && specialFilter;
    });
  };

  return {
    items,
    categories,
    subcategories,
    specials,
    getItems,
    filterItems,
  };
});
